module.exports = __webpack_public_path__ + "img/right-side-menu-filters.2ef726b2.svg";